import { FastArrowRightIcon } from '@synoptic/ui-kit/icons/react/fast-arrow-right.js';
import clsx from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { navButton } from './nav-button.css';

export const NavButton = ({
  className,
  collapsed,
  ...props
}: ComponentPropsWithRef<'button'> & { collapsed: boolean }) => {
  return (
    <button
      type="button"
      data-collapsed={collapsed}
      className={clsx(navButton, className)}
      {...props}
    >
      <FastArrowRightIcon width={20} height={20} />
    </button>
  );
};
